import React, { useContext, useState } from 'react'
import { GlobalContext } from '../../services/context'
import './SearchResult.scss'
import ScaleTicketDetails from '../../views/ContractDashboard/ScaleTicketDetails'

const SearchResult = ({ type, data }) => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const clickAnchor = (e, value) => {
    e.preventDefault()
    let dispatchType = 'GO_TO_COMPANY_DETAIL_VIEW'
    let user_id
    let company_id = value['company_id']
    if (value.user_id) {
      user_id = value['user_id']
      dispatchType = 'GO_TO_USER_DETAIL'
      company_id = 'admin'
    }
    trackEvent(`${type}_link_clicked`, { companyId: company_id, userId: user_id, name: value.name })
    dispatch({ type: dispatchType, payload: { company_id, id: user_id, detailView: { title: value.name, previous: 'Back' } } })
  }
  const textGen = attribute => {
    return data[`${type}_${attribute}`]? data[`${type}_${attribute}`] : '---' 
  }
  const addressGen = () => {
    const addr = data[`${type}_address1`]? data[`${type}_address1`] : ''
    const city =  data[`${type}_city`] ? data[`${type}_city`] : ''
    const state =  data[`${type}_state`] ? data[`${type}_state`] : ''
    const zip = data[`${type}_zip`] ? data[`${type}_zip`] : ''
    let fullAdd = ''
    if(addr){
      fullAdd = addr
    }
    if(city){
      fullAdd = addr? `${fullAdd} ${city}` : city
    }
    if(state) {
      fullAdd = addr || city? `${fullAdd}, ${state}` : state
    }
    if(zip) {
      fullAdd = addr || city || state ? `${fullAdd} ${zip}` : zip
    }
    if(fullAdd === 'N/A N/A, N/A') {
      fullAdd = '---'
    }

    return fullAdd
  }

  const [showTicketDetails, setShowTicketDetails] = useState(false)

  const showTicketDetailsFunc = () => {
    setShowTicketDetails(prev => !prev)
  }

  return (
    <>
      {type === 'contract' ? 
        <a href={`/company/${data['external_reference_id']}/contracts/${data['contract_id']}`} className='ml30 mr30 mih60 df jcsb aic bb1-s-gray2'>
          <div className='df fxdrc flx1'>
            <div className='fw600 fz18 tal'>{data.grower_name}</div>
            <div className='tal'>{data.sap_id}</div>
          </div>
          <div className='df fxdrc flx1'>
            <div>{data.contract_year}</div>
            <div>{data.contract_status}</div>
          </div>
          <div className='df fxdrc aifs flx1'>
            <div>{data.reseller}</div>
          </div>
        </a> : type === 'ticket' ? 
          <div onClick={showTicketDetailsFunc} className='ml30 mr30 mih60 df jcsb aic bb1-s-gray2'>
            <div className='df fxdrc flx1'>
              <div className='fw600 fz18 tal'>{data.grower_name}</div>
              <div className='tal'>{data.net_quantity} bushels</div>
            </div>
            <div className='df fxdrc flx1'>
              <div>{data.grain_receiver}</div>
              <div>{data.production_plan_year}</div>
            </div>
            <div className='df fxdrc aifs flx1'>
              <div>{data.scale_ticket_number}</div>
              <div>{data.scale_ticket_date}</div>
            </div>
            {showTicketDetails ? <ScaleTicketDetails data={data}/> : null}
          </div> :
          <a href={`/${type}/${data[`${type}_id`]}`} onClick={e => clickAnchor(e, data)} className='ml30 mr30 mih60 df jcsb aic bb1-s-gray2'>
            <div className='df fxdrc flx1'>
              <div className='fw600 fz18 tal'>{data.name}</div>
              <div className='tal'>{addressGen()}</div>
            </div>
            <div className='df fxdrc flx1'>
              <div>{textGen('sap_id')}</div>
              <div>{textGen('phone')}</div>
            </div>
            <div className='df fxdrc aifs flx1'>
              <div>Type: {type}</div>
              <div>{textGen('email')}</div>
            </div>
          </a>
      }
    </>
  )
}

export default SearchResult